import { useState } from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icRank from './assets/img/ic-rank.svg';
import icYear from './assets/img/ic-calendar.svg';
import icRevenue  from './assets/img/ic-sack.svg';
import icPercentage from './assets/img/ic-graph-rise.svg';
import icProfit from './assets/img/ic-graph-compare.svg';


const CompanyAddFortune = ({ formData, handleChange, setFormData, handleFortuneSubmit, isEditPage}) => {
    const [isEditing, setIsEditing] = useState(!isEditPage); // ✅ If adding, fields are enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values

    // ✅ Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };

    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleFortuneSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleFortuneSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleFortuneSubmit is not a function.');
        }
    };

    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    return (
        <>
            <Card>
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">6.</span>Fortune 1000</h3>
                            <hr />
                        </Col>
                    </Row>
                    <>
                        {isEditing ? (
                            <>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group controlId="fortune">
                                            <Form.Label>Is your company a Fortune 1000 company? *</Form.Label>
                                        </Form.Group>      
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group controlId="fortune">
                                            <label className="radio-option" htmlFor="fortuneYes">
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        id="fortuneYes"
                                                        name="isFortusne"
                                                        value="true"
                                                        className="form-check-input"
                                                        checked={formData.isFortune === true}
                                                        onChange={() =>
                                                            setFormData((prevData) => ({ ...prevData, isFortune: true }))
                                                        }
                                                        required
                                                        disabled={!isEditing}
                                                    />
                                                    <span className="form-check-label">Yes</span>
                                                </div>
                                            </label>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <label className="radio-option" htmlFor="fortuneNo">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    id="fortuneNo"
                                                    name="isFortusne"
                                                    value="false"
                                                    className="form-check-input"
                                                    checked={formData.isFortune === false}
                                                    onChange={() =>
                                                        setFormData((prevData) => ({ ...prevData, isFortune: false }))
                                                    }
                                                    required
                                                    disabled={!isEditing}
                                                />
                                                <span className="form-check-label">No</span>
                                            </div>
                                        </label>
                                    </Col>
                                </Row>
                                {formData.isFortune && (
                                    <>
                                        <Row>
                                            <Col md={2}>
                                                {/* Rank */}
                                                <Form.Group controlId="fortuneRank">
                                                    <Form.Label>Rank</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="fortuneRank"
                                                        value={formData.fortuneRank}
                                                        onChange={(e) => {
                                                            const value = Math.min(1000, Math.max(1, Number(e.target.value))); // ✅ Ensures value stays between 1 and 1000
                                                            handleChange({ target: { name: 'fortuneRank', value } });
                                                        }}
                                                        min="1" // ✅ Minimum value set to 0
                                                        max="1000" // ✅ Maximum value set to 100
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                                {/* Fortune Year */}
                                                <Form.Group controlId="fortuneYear">
                                                    <Form.Label>Year</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="fortuneYear"
                                                        value={formData.fortuneYear}
                                                        onChange={(e) => {
                                                            const currentYear = new Date().getFullYear(); // ✅ Dynamically gets the current year
                                                            const value = Math.min(currentYear, Math.max(1955, Number(e.target.value))); // ✅ Clamps between 1955 and current year
                                                            handleChange({ target: { name: 'fortuneYear', value } });
                                                        }}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                                {/* Fortune Revenue ($M) */}
                                                <Form.Group controlId="fortuneRevenue">
                                                    <Form.Label>Revenue ($M)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="fortuneRevenue"
                                                        step="0.01"
                                                        value={formData.fortuneRevenue}
                                                        onChange={handleChange}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                {/* Revenue percent change */}
                                                <Form.Group controlId="fortunePercentChange">
                                                    <Form.Label>Revenue percent change</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="fortunePercentChange"
                                                        step="0.01"
                                                        value={formData.fortunePercentChange}
                                                        onChange={handleChange}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                {/* Profit ($M) */}
                                                <Form.Group controlId="fortuneProfit">
                                                    <Form.Label>Profit ($M)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="fortuneProfit"
                                                        step="0.01"
                                                        value={formData.fortuneProfit}
                                                        onChange={handleChange}
                                                        disabled={!isEditing} // ✅ Disable input when not in edit mode
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                            </>
                        ) :(
                            // Not editing
                            <>
                                {formData.isFortune && (
                                    <Row className="mb-3">
                                        <Col md={2}>
                                            <div className="icon-text">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icRank} alt="Rank" />
                                                </span>
                                                <span className="text">
                                                    Rank:
                                                    <br />
                                                    <strong>
                                                        {formData.fortuneRank || "N/A"}
                                                    </strong>
                                                </span>
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="icon-text">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icYear} alt="Year" />
                                                </span>
                                                <span className="text">
                                                    Year:
                                                    <br />
                                                    <strong>
                                                        {formData.fortuneYear || "N/A"}
                                                    </strong>
                                                </span>
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="icon-text">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icRevenue} alt="Revenue" />
                                                </span>
                                                <span className="text">
                                                    Revenue:
                                                    <br />
                                                    <strong>
                                                        {formData.fortuneRevenue || "N/A"}
                                                    </strong>
                                                </span>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="icon-text">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icPercentage} alt="Revenue percent change" />
                                                </span>
                                                <span className="text">
                                                    Revenue percent change:
                                                    <br />
                                                    <strong>
                                                        {formData.fortunePercentChange || "N/A"}
                                                    </strong>
                                                </span>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="icon-text">
                                                <span className="icon" aria-hidden="true">
                                                    <Image src={icProfit} alt="Profit" />
                                                </span>
                                                <span className="text">
                                                    Profit:
                                                    <br />
                                                    <strong>
                                                        {formData.fortuneProfit || "N/A"}
                                                    </strong>
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </>
                        )}
                    </>
                </Card.Body>
            </Card>
        </>
    );
};

export default CompanyAddFortune;
